import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var CbcApplyAction;
(function (CbcApplyAction) {
    CbcApplyAction["REQUEST"] = "CBC_APPLY_REQUEST";
    CbcApplyAction["SUCCESS"] = "CBC_APPLY_SUCCESS";
    CbcApplyAction["ERROR"] = "CBC_APPLY_ERROR";
})(CbcApplyAction || (CbcApplyAction = {}));
export function applyForCBC({ apiEndpoint, body }) {
    return (dispatch) => {
        dispatch({
            type: CbcApplyAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: apiEndpoint,
            acceptErrors: true,
            action: CbcApplyAction.REQUEST
        }), body).then(json => {
            dispatch({
                type: CbcApplyAction.SUCCESS
            });
            return json.RESPONSE;
        }, error => {
            dispatch({
                type: CbcApplyAction.ERROR,
                error
            });
        });
    };
}
